export default {
  pickDate: {
    is: 'Veldu dagsetningu',
    en: 'Select date',
  },
  continue: {
    is: 'Áfram',
    en: 'Continue',
  },
  comment: {
    is: 'Athugasemd',
    en: 'Comment',
  },
  pickTime: {
    is: 'Veldu tíma',
    en: 'Select time',
  },
};
